<template>
  <div>
    <router-view v-show='this.$route.matched.length==3'></router-view>
    <PageHeaderLayout v-show='this.$route.matched.length==2'>
      <div class='main-page-content'>
        <div class='table-search'>
          <el-form :inline='true' size='mini' :model='searchCondition'>
            <el-form-item>
              <el-input v-model='searchCondition.keyword' placeholder='关键词搜索：姓名/账号/昵称/手机号/工号'
                        style='width: 280px'
                        clearable></el-input>
            </el-form-item>
            <el-form-item label=''>
              <el-select v-model='searchCondition.user_status' style='width: 100px!important;' placeholder='启用状态'
                         @change='searchButton' clearable>
                <el-option value='' label='全部'></el-option>
                <el-option :value='item.value' :label='item.label' v-for='(item) in userStatusOptions'
                           :key='item.value'></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label=''>
              <el-select placeholder='在职情况' v-model='searchCondition.is_leave' style='width: 100px' clearable>
                <el-option label='在职' value='N'></el-option>
                <el-option label='离职' value='Y'></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label=''>
              <el-select v-model='searchCondition.role_id' style='width: 120px' placeholder='选择角色'
                         @change='searchButton' clearable>
                <el-option :value='role.id' :label='role.display_name' v-for='(role) in rolesList'
                           :key='role.id'></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-select v-model='currentField' placeholder='精确匹配项' style='width: 140px' clearable>
                <el-option :value='item.value' :label='item.label' v-for='(item) in condFieldOptions'
                           :key='item.value'></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label=''>
              <el-input v-model='searchCondition[currentField]' :placeholder='`精确匹配内容`' clearable></el-input>
            </el-form-item>
            <el-form-item v-if='showMore'>
              <CompanyCascader @handleSelect='handleDeptSelect'></CompanyCascader>
            </el-form-item>
            <el-form-item v-if='showMore'>
              <el-select multiple v-model='searchCondition.status_bind' placeholder='是否关联钉钉，选择后点击搜索按钮'
                         style='width: 140px'
                         collapse-tags
                         clearable>
                <el-option value='Y' label='是'></el-option>
                <el-option value='N' label='否'></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type='primary' icon='el-icon-search' @click='searchButton'>搜索</el-button>
              <el-button type='text' :icon='!showMore?"el-icon-caret-bottom":"el-icon-caret-top"'
                         @click='showMore=!showMore'>
                {{ !showMore ? '展开' : '隐藏' }}
              </el-button>

            </el-form-item>
          </el-form>
          <!--        操作栏-->
          <div style='display: flex;flex-direction: row;justify-content: space-between;margin-bottom: 8px;padding-bottom: 8px'>
            <div style='display: flex;flex-direction: row;gap: 5px'>
              <el-button type='primary' icon='el-icon-plus' @click='addButton(0)' v-if="userPermissions.indexOf('user_create') > -1">新增</el-button>
              <export-btn ref='refExportLink' type='default'
                          :lint-title='`导出表格`'
                          :can-export="userPermissions.indexOf('user_export')>-1"
                          @export='exportExcel'></export-btn>
            </div>
            <div style='display: flex;flex-direction: row;justify-content: right;gap: 2px'>
              <el-dropdown>
                <el-button type="primary">
                  更多菜单<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <el-button class='page-btn'  type='text' size='mini' @click="jumpToPage('employee')"
                               icon='el-icon-tickets'
                               v-if="userPermissions.indexOf('employee_list') != -1">员工信息
                    </el-button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-button class='page-btn'  type='text' size='mini' @click="jumpToPage('purview')"
                               icon='el-icon-tickets'
                               v-if="userPermissions.indexOf('user_purview') != -1">用户权限
                    </el-button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-button class='page-btn'  type='text' size='mini' @click="jumpToPage('LoginLog')"
                               icon='el-icon-date'
                               v-if="userPermissions.indexOf('user_login_record') != -1">登录日志
                    </el-button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-button class='page-btn'  type='text' size='mini' @click="jumpToPage('PageOnlineAdmin')"
                               icon='el-icon-date'
                               v-if="userPermissions.indexOf('user_login_record') != -1">页面在线
                    </el-button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-button class='page-btn'  type='text' size='mini' @click="jumpToPage('UserOnline')"
                               icon='el-icon-user'>
                      在线用户
                    </el-button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-button class='page-btn'  type='text' size='mini' @click="jumpToPage('UserDepart')"
                               icon='el-icon-user'
                               v-if="userPermissions.indexOf('user_leave_list') != -1">离职人员
                    </el-button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-button class='page-btn' type='text'   size='mini' @click="jumpToPage('dingUserInfo')" icon='el-icon-user'
                               v-if="userPermissions.indexOf('user_dingTalk') != -1">钉钉成员
                    </el-button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-button class='page-btn' type='text' size='mini' @click="jumpToPage('userWechat')"
                               icon='el-icon-user'
                               title='招商小程序'
                               v-if="userPermissions.indexOf('user_wechat') != -1">微信用户
                    </el-button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-button class='page-btn' type='text' size='mini' @click="jumpToPage('memberList')"
                               icon='el-icon-user-solid'
                               title='组织成员在职离职转组一览' v-if="userPermissions.indexOf('user_member') != -1">成员异动一览
                    </el-button>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>

        <div class='default-table' v-loading='loadingStaus'
             element-loading-text='加载中……'
             element-loading-spinner='el-icon-loading'>
          <MlPageTable :show-slot='!loadingStaus'
                       :all-columns='userColumns'
                       :table-name='tableName'
                       :data-list='userList'
                       :limit.sync='pagingData.page_size'
                       :page.sync='pagingData.current_page'
                       :total.sync='pagingData.total'
                       :show-index='true'
                       height='680px'
                       highlight-current-row
                       :cell-class-name='addCellClass'
                       @row-dblclick='dblclickRow'
                       @sort-change='sortChange'
                       @getList='getUserList'
                       border>

            <el-table-column label='启/停' prop='user_status' width='100'
                             align='center'  v-if="userPermissions.indexOf('user_edit') !== -1">
              <template slot-scope='scope'>
                <el-switch
                  v-model='scope.row.user_status'
                  :active-value='1'
                  :inactive-value='0'
                  @change='handleStatusChange(scope.row)'
                ></el-switch>
              </template>
            </el-table-column>
            <!--            <el-table-column label='钉钉绑定' width='110' align='center'>-->
            <!--              <template slot-scope='{row}'>-->
            <!--                <el-link @click='showBindDialog(row)'>-->
            <!--                  <el-tag v-if='row.userid' type='success' effect='plain'><span class='el-icon-circle-check'></span>&nbsp;已绑定-->
            <!--                  </el-tag>-->
            <!--                  <el-tag v-else type='danger' effect='plain'><span class='el-icon-circle-close'></span>&nbsp;未绑定-->
            <!--                  </el-tag>-->
            <!--                </el-link>-->
            <!--              </template>-->
            <!--            </el-table-column>-->

            <el-table-column slot='handle-column' align='center' fixed='right' label='操作' width='260px'>
              <template slot-scope='{row}'>
                <el-button type='text' size='mini' v-if="userPermissions.indexOf('user_detail') > -1"
                           @click='openMemberDetail(row)' icon='el-icon-view'>详情
                </el-button>
                &nbsp;
                <el-button type='text' size='mini' v-if="userPermissions.indexOf('user_edit') > -1"
                           @click='editButton(row.id,"edit")' icon='el-icon-edit'>编辑
                </el-button>
                &nbsp;
                <el-dropdown>
                  <span class='el-dropdown-link'>
                    更多<i class='el-icon-arrow-down el-icon--right'></i>
                  </span>
                  <el-dropdown-menu slot='dropdown'>
                    <el-dropdown-item>
                      <el-button  type='text' size='mini' icon='el-icon-switch-button' @click='handleEventStatus(row)' v-if="userPermissions.indexOf('user_edit') !== -1">
                        {{row.user_status==1?"停用":"启用 "}}
                      </el-button>
                    </el-dropdown-item>
                    <el-dropdown-item divided>
                      <el-button type='text' size='mini' v-if="userPermissions.indexOf('user_group') !== -1"
                                 @click='userGroupBinding(row)' icon='el-icon-s-fold'>组别
                      </el-button>
                    </el-dropdown-item>
                    <el-dropdown-item divided>
                      <el-button v-if="userPermissions.indexOf('user_pwd') !== -1" icon='el-icon-key' size='mini'
                                 type='text' @click='editButton(row.id,"password")'>密码
                      </el-button>
                    </el-dropdown-item>
                    <el-dropdown-item divided>
                      <el-button type='text' size='mini' v-if="userPermissions.indexOf('user_edit_role') !== -1"
                                 @click='editButton(row.id,"role")' icon='el-icon-edit'>角色
                      </el-button>
                    </el-dropdown-item>
                    <el-dropdown-item divided>
                      <el-button v-if="userPermissions.indexOf('user_delete') !== -1" icon='el-icon-delete'
                                 size='mini' type='text'
                                 @click='deleteButton(row.id)'>删除
                      </el-button>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </MlPageTable>
        </div>
      </div>
    </PageHeaderLayout>

    <!--    用户信息-->
    <ApeDrawer :drawerData='drawerData' @drawerClose='drawerClose' @drawerConfirm='drawerConfirm'>
      <template slot='ape-drawer'>
        <div v-if='formData.userid' style='margin: 10px'>
          <el-tag type='success' effect='plain'><span class='el-icon-circle-check'></span>&nbsp;钉钉已绑定</el-tag>
        </div>
        <el-form :model='formData' :rules='rules' ref='userForm' label-position='right' label-width='96px'>
          <el-row>
            <el-col :span='22'>
              <el-form-item label='账号' prop='username'>
                <el-input v-model='formData.username' placeholder='账号，建议采用姓名首字母加工号，保证唯一'></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span='22'>
              <el-form-item label='昵称' prop='nickname'>
                <el-input v-model='formData.nickname' placeholder='昵称'></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span='22'>
              <el-form-item label='姓名' prop='name'>
                <el-input v-model='formData.name' placeholder='用户真实姓名'></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span='22'>
              <el-form-item label='手机号' prop='mobile'>
                <el-input v-model='formData.mobile' placeholder='手机号'></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span='22'>
              <el-form-item label='Email' prop='email'>
                <el-input v-model='formData.email'></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span='22'>
              <el-form-item label='工号' prop='job_number'>
                <el-input v-model='formData.job_number'></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if='!this.formData.id'>
            <el-col :span='22'>
              <el-form-item label='密码' prop='password'>
                <el-input v-model='formData.password'></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if='!this.formData.id'>
            <el-col :span='22'>
              <el-form-item label='角色绑定' prop='user_roles'>
                <el-select v-model='formData.user_roles' multiple filterable clearable placeholder='请选择'
                           style='width: 100%'>
                  <el-option
                    v-for='item in rolesList'
                    :key='item.id'
                    :label='item.display_name'
                    :value='item.id'>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!--          <el-row>-->
          <!--            <el-col>{{formData.user_roles}}</el-col>-->
          <!--          </el-row>-->
        </el-form>
      </template>
    </ApeDrawer>
    <!--    分组信息-->
    <ApeDrawer :drawerData='drawerGroupData' @drawerClose='drawerGroupClose' @drawerConfirm='drawerGroupConfirm'>
      <template slot='ape-drawer'>
        <div class='drawer-roles-premissions'>
          <el-checkbox :indeterminate='isIndeterminate' checked="true" v-model='checkAll'
                       @change="checkedIndeterminate">
            全选({{ userGroups.length }}/{{ groupList.length }})
          </el-checkbox>
          <div style='margin: 15px 0;'></div>
          <el-checkbox-group v-model='userGroups' @change='handleCheckedCitiesChange' size='small'
                             style='text-align: left'>
            <el-checkbox v-for='(group,index) in groupList' :label='group.name' :key='group.name' border
                         style='margin-bottom: 5px;width: 180px'>
              {{ index + 1 }}）{{ group.display_name }}({{ group.artists_count || 0 }})
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </template>
    </ApeDrawer>
    <!--    用户登录日志-->
    <ApeDrawer :drawerData='drawerLoginData' @drawerClose='drawerLoginRecordClose'>
      <template slot='ape-drawer'>
        <LoginRecord :user-id='currentUserId' ref='userLoginRecord'></LoginRecord>
      </template>
    </ApeDrawer>
    <el-dialog title='钉钉账号关联' :visible.sync='dialogVisible' width='600px'>
      <el-form label-suffix='：' :model='formData' label-width='100px'>
        <el-form-item label='用户'>{{ formData.nickname || '' }}</el-form-item>
        <el-form-item label='手机'>{{ formData.mobile || '' }}</el-form-item>
        <el-form-item label='钉钉ID'>{{ formData.userid || '' }}</el-form-item>
        <el-form-item label='钉钉ID'>
          <el-input v-model='bindForm.userid' placeholder='钉钉Userid' clearable></el-input>
        </el-form-item>
        <el-form-item label='修改原因'>
          <el-input v-model='bindForm.reason' placeholder='修改钉钉ID的原因' clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot='footer' class='dialog-footer'>
        <el-button @click='dialogVisible = false'>取 消</el-button>
        <el-button type='primary' @click='saveBindDing'>确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title='重置密码提示' :visible.sync='passWordDialog' width='400px' center>
      <el-form label-suffix=':' :model='formData' label-width='80px'>
        <el-form-item label='用户'>{{ formData.nickname || '' }}</el-form-item>
        <el-form-item label='手机'>{{ formData.mobile || '' }}</el-form-item>
        <el-form-item label='密码' prop='password'>
          <el-input v-model='formData.password' style='width: 160px'></el-input>
          <el-link style='margin-left: 10px' type='primary' @click='generateRandomPassword'>随机密码</el-link>
        </el-form-item>
      </el-form>
      <span slot='footer' class='dialog-footer'>
        <el-button @click='copyBtn' type='primary'>保存并复制</el-button>
        <!--       </span>-->
        <!--        <el-button type="primary">保存</el-button>-->
      </span>
    </el-dialog>
    <el-dialog title='用户角色修改' :visible.sync='roleDialog' width='800'>
      <el-form label-suffix=':' :model='formData' label-width='80px'>
        <el-form-item label='用户'>{{ formData.nickname || '' }}</el-form-item>
        <!--        <el-form-item label='手机'>{{ formData.mobile || '' }}</el-form-item>-->
        <el-form-item label='角色'>
          <el-checkbox-group v-model='formData.user_roles'>
            <el-checkbox v-for='item in rolesList' :key='item.id' :label='item.id'>
              {{ item.display_name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot='footer' class='dialog-footer'>
        <el-button type='primary' @click='saveRole'>确定</el-button>
        <el-button @click='roleDialog = false'>取消</el-button>
      </span>
    </el-dialog>

    <!--    成员详情抽屉-->
    <ApeDrawer :drawerData='memberDetailData' @drawerClose='memberDetailClose'>
      <template slot='ape-drawer'>
        <div v-if='memberDetail' class='member-detail'>
          <el-tabs v-model='memberDetailTab'>
            <!--  基本信息  -->
            <el-tab-pane label='基本信息' name='base'>
              <div class='detail-grid'>
                <div class='detail-item' v-for='(item, key) in memberBaseFields' :key='key'>
                  <div class='detail-label'>{{ item.label }}</div>
                  <div class='detail-value'>{{ item.value }}</div>
                </div>
              </div>
            </el-tab-pane>
            <!--  钉钉信息  -->
            <el-tab-pane label='钉钉信息' name='ding'>
              <div class='detail-grid'>
                <div class='detail-item' v-for='(item, key) in memberDingFields' :key='key'>
                  <div class='detail-label'>{{ item.label }}</div>
                  <div class='detail-value'>{{ item.value }}</div>
                </div>
              </div>
            </el-tab-pane>
            <!--  飞书信息  -->
            <el-tab-pane label='飞书信息' name='feishu'>
              <div class='detail-toolbar'>
                <span class='toolbar-title'>飞书绑定信息</span>
                <el-button type='primary' size='mini' icon='el-icon-refresh'
                           :loading='feishuSyncLoading' @click='syncFeishu'>同步</el-button>
              </div>
              <div class='detail-grid'>
                <div class='detail-item' v-for='(item, key) in memberFeishuFields' :key='key'>
                  <div class='detail-label'>{{ item.label }}</div>
                  <div class='detail-value'>{{ item.value }}</div>
                </div>
              </div>
            </el-tab-pane>
            <!--  时间线  -->
            <el-tab-pane label='时间线' name='timeline'>
              <el-timeline v-if='memberDetail.timeline && memberDetail.timeline.length'>
                <el-timeline-item v-for='(t, idx) in memberDetail.timeline' :key='idx'
                                  :timestamp='t.time' placement='top' :type='timelineType(t.type)'>
                  <div class='timeline-title'>{{ t.title }}</div>
                  <div class='timeline-desc' v-if='t.desc'>{{ t.desc }}</div>
                </el-timeline-item>
              </el-timeline>
              <div v-else class='timeline-empty'>暂无时间线记录</div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </template>
    </ApeDrawer>

    <!--    飞书信息-同步展示/确认更新弹窗-->
    <el-dialog title='飞书信息同步' :visible.sync='feishuSyncDialog.visible' width='640px'
               :close-on-click-modal='false'>
      <div v-loading='feishuSyncLoading' class='feishu-sync-body'>
        <div v-if='feishuSyncData'>
          <el-alert type='info' :closable='false' show-icon
                    title='已获取飞书最新成员信息，是否更新为最新成员信息？'></el-alert>
          <div class='sync-section-title'>当前绑定</div>
          <div class='detail-grid'>
            <div class='detail-item' v-for='(item, key) in feishuBoundFields' :key='key'>
              <div class='detail-label'>{{ item.label }}</div>
              <div class='detail-value'>{{ item.value }}</div>
            </div>
          </div>
          <div class='sync-section-title'>飞书最新成员信息</div>
          <div class='detail-grid'>
            <div class='detail-item' v-for='(item, key) in feishuLatestFields' :key='key'>
              <div class='detail-label'>{{ item.label }}</div>
              <div class='detail-value'>{{ item.value }}</div>
            </div>
          </div>
        </div>
      </div>
      <span slot='footer' class='dialog-footer'>
        <el-button @click='feishuSyncDialog.visible = false'>取消</el-button>
        <el-button type='primary' :loading='feishuSyncLoading' @click='confirmFeishuUpdate'>更新为最新成员信息</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import {mapGetters} from 'vuex'
import LoginRecord from '@/pages/user/LoginRecord'
import UserNameTag from '@/pages/user/components/UserNameTag'
import MSetTable from '@/components/common/MSetTable'
import MColumnSetting from '@/components/common/MColumnSetting'
import ExportBtn from '@/components/export/ExportBtn'
import MlPageTable from '@/components/common/MlPageTable'
import CompanyCascader from '@/components/dept/CompanyCascader'

export default {
  name: 'UserList',
  components: {
    CompanyCascader,
    MlPageTable,
    UserNameTag,
    PageHeaderLayout,
    ApeTable,
    LoginRecord,
    ApeDrawer,
    MSetTable,
    MColumnSetting,
    ExportBtn
  },
  data() {
    return {
      dialogVisible: false,
      bindForm: { id: null, userid: null, reason: null },
      showMore: false,
      // 搜索条件
      searchCondition: {
        keyword: null,
        dpt_id: null,
        username: null,
        nickname: null,
        name: null,
        mobile: null,
        job_number: null,
        user_status: 1,
        role_id: null,
        is_leave: null,
        status_bind: []
      },
      userStatusOptions: [
        { value: 1, label: '正常' },
        { value: 2, label: '禁用' },
        { value: 0, label: '停用' }
      ],
      condFieldOptions: [
        { value: 'name', label: '姓名' },
        { value: 'username', label: '账号' },
        { value: 'nickname', label: '昵称' },
        { value: 'mobile', label: '手机号' },
        { value: 'job_number', label: '工号' }
      ],
      currentField: null,
      loadingStaus: true,
      columns: [],
      userColumns: [
        { hide: true, prop: 'avatar', label: '头像', width: 60, sortable: false, fixed: true, type: 'image' },
        { hide: false, prop: 'nickname', label: '昵称', width: 100, sortable: false, fixed: false },
        { hide: false, prop: 'username', label: '账号', width: 100, sortable: true, fixed: false },
        { hide: false, prop: 'name', label: '姓名', width: 100, sortable: false, fixed: false },
        // { hide: false, prop: 'job_number', label: '工号', width: 100, sortable: true, fixed: false },
        { hide: false, prop: 'mobile', label: '手机号', width: 100, sortable: true, fixed: false },
        { hide: false, prop: 'role_names', label: '角色', width: 220, sortable: false, fixed: false },
        { hide: false, prop: 'dept_names', label: '部门', width: 220, sortable: false, fixed: false },
        // { hide: false, prop: 'position', label: '岗位', width: 120, sortable: false, fixed: false },
        // { hide: false, prop: 'hired_at', label: '入职时间', width: 100, sortable: true, fixed: false },
        { hide: false, prop: '_is_leave', label: '在职情况', width: 100, sortable: true, fixed: false },
        // { hide: true, prop: 'leave_date', label: '离职时间', width: 100, sortable: true, fixed: false },
        // { hide: false, prop: 'login_at', label: '最近登录时间', width: 140, sortable: true, fixed: false },
        // { hide: false, prop: 'last_login_ip', label: '最近登录IP', width: 140, sortable: true, fixed: false },
        // {
        //   hide: false,
        //   prop: '_user_status',
        //   label: '状态',
        //   width: 80,
        //   sortable: true,
        //   fixed: false
        // },
        // {
        //   hide: true,
        //   prop: 'userid',
        //   label: '钉钉ID',
        //   slotName: 'userid',
        //   slot: true,
        //   width: 120,
        //   sortable: true,
        //   fixed: false
        // },
        // { hide: false, prop: 'created_at', label: '注册时间', width: 140, sortable: true, fixed: false },
        {
          hide: false,
          prop: '_user_status',
          label: '状态',
          width: 80,
          sortable: true,
          fixed: false
        },
        { hide: true, prop: 'updated_at', label: '修改时间', width: 140, sortable: true, fixed: false }
      ],
      // 表格列表数据
      userList: [],
      // 分页信息
      pagingData: {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        offset: 0,
        page_size: 15,
        current_page: 1
      },
      // 分页的offset,序号列使用
      offset: 0,
      // 表单结构
      formData: {
        user_roles: [],
        username: null,
        nickname: null,
        job_number: null
      },
      // 表单验证
      rules: {
        mobile: [
          { required: true, message: '输入手机号', trigger: 'blur' },
          { pattern: this.$utils.regular.mobile, message: '手机号格式错误', trigger: 'blur' }
        ],
        username: [
          { required: true, message: '输入账号', trigger: 'blur' },
          { pattern: this.$utils.regular.enNum3to20, message: '用户名格式3-20位英文数字', trigger: 'blur' }
        ],
        // email: [
        //   {required: true, message: '输入邮箱', trigger: 'blur'},
        // ],
        // job_number: [
        //   {required: true, message: '输入工号', trigger: 'blur'},
        // ],
        nickname: [
          { required: true, message: '输入昵称', trigger: 'blur' }
        ]
      },
      // 抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        // direction: 'right',
        title: '',
        width_height: '480px'
        // mask: false,
        // close_name: '关 闭',
        // confirm_name: '打 印',
      },
      rolesList: [],
      userRoles: [],
      // 抽屉数据
      drawerGroupData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        // direction: 'right',
        title: '',
        width_height: '990px'
        // mask: false,
        // close_name: '关 闭',
        // confirm_name: '打 印',
      },
      groupList: [],
      userGroups: [],
      currentUserId: null,
      checkAll: false,
      isIndeterminate: true,
      drawerLoginData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        // direction: 'right',
        title: '',
        width_height: '990px',
        show_footer: false
        // mask: false,
        // close_name: '关 闭',
        // confirm_name: '打 印',
      },
      //排序
      orderSort: { 'created_at': 'desc', id: 'desc' },
      customColumnShow: false,
      isColSet: false,
      tableName: 'user',
      passWordDialog: false,
      resetPassword: '',
      copyInfo: '请重试',
      roleDialog: false,
      // 成员详情抽屉
      memberDetailData: {
        visible: false,
        loading: false,
        loading_text: '玩命加载中……',
        title: '成员详情',
        width_height: '720px',
        show_footer: false
      },
      memberDetailTab: 'base',
      memberDetail: null,
      // 飞书信息-同步
      feishuSyncLoading: false,
      feishuSyncDialog: {
        visible: false
      },
      feishuSyncData: null

    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    '$route.matched': function(n, o) {
      if (n.length === 2) {
        this.init()
      }
    }
  },
  computed: {
    ...mapGetters(['userPermissions', 'buttonType']),
    // 成员详情-基本信息字段
    memberBaseFields() {
      if (!this.memberDetail)
        return []
      const b = this.memberDetail.base
      return [
        { label: 'ID', value: b.id },
        { label: '姓名', value: b.name || '-' },
        { label: '昵称', value: b.nickname || '-' },
        { label: '账号', value: b.username || '-' },
        { label: '手机号', value: b.mobile || '-' },
        { label: '工号', value: b.job_number || '-' },
        { label: '邮箱', value: b.email || '-' },
        { label: '状态', value: b._user_status || '-' },
        { label: '在职情况', value: b._is_leave || '-' },
        { label: '部门', value: (this.memberDetail.dept_names || []).join('、') || '-' },
        { label: '角色', value: (this.memberDetail.role_names || []).join('、') || '-' },
        { label: '最近登录时间', value: b.login_at || '-' },
        { label: '最近登录IP', value: b.last_login_ip || '-' },
        { label: '注册时间', value: b.created_at || '-' },
        { label: '更新时间', value: b.updated_at || '-' }
      ]
    },
    // 成员详情-钉钉信息字段
    memberDingFields() {
      if (!this.memberDetail)
        return []
      const b = this.memberDetail.base
      const du = this.memberDetail.ding_user || {}
      const info = this.memberDetail.ding_user_info || {}
      return [
        { label: '是否绑定', value: b.ding_bound ? '已绑定' : '未绑定' },
        { label: '钉钉绑定时间', value: b.ding_bind_at || '-' },
        { label: '钉钉ID（ding_user_id）', value: b.ding_user_id || '-' },
        { label: '钉钉成员userid', value: b.userid || '-' },
        { label: 'union_id', value: b.union_id || '-' },
        { label: '钉钉昵称', value: du.nick || '-' },
        { label: '钉钉ding_id', value: du.ding_id || '-' },
        { label: '钉钉open_id', value: du.open_id || '-' },
        { label: '记录创建时间', value: du.created_at || '-' },
        { label: '岗位', value: info.position || '-' },
        { label: '入职时间', value: info.hiredDate || '-' },
        { label: '离职日期', value: info.leave_date || '-' }
      ]
    },
    // 成员详情-飞书信息字段
    memberFeishuFields() {
      if (!this.memberDetail)
        return []
      const b = this.memberDetail.base
      const fs = this.memberDetail.feishu || {}
      return [
        { label: '是否绑定', value: b.fs_bound ? '已绑定' : '未绑定' },
        { label: '飞书绑定时间', value: fs.fs_bind_at || '-' },
        { label: '飞书 user_id', value: fs.fs_user_id || '-' },
        { label: '飞书 union_id', value: fs.fs_union_id || '-' },
        { label: '飞书 open_id', value: fs.fs_open_id || '-' }
      ]
    },
    // 飞书同步-当前绑定信息字段
    feishuBoundFields() {
      const b = this.feishuSyncData && this.feishuSyncData.bound ? this.feishuSyncData.bound : {}
      return [
        { label: '飞书 user_id', value: b.fs_user_id || '-' },
        { label: '飞书 union_id', value: b.fs_union_id || '-' },
        { label: '飞书 open_id', value: b.fs_open_id || '-' },
        { label: '飞书绑定时间', value: b.fs_bind_at || '-' }
      ]
    },
    // 飞书同步-最新成员信息字段
    feishuLatestFields() {
      const f = this.feishuSyncData && this.feishuSyncData.latest ? this.feishuSyncData.latest : {}
      return [
        { label: '姓名', value: f.name || '-' },
        { label: '英文名', value: f.en_name || '-' },
        { label: '手机号', value: f.mobile || '-' },
        { label: '邮箱', value: f.email || '-' },
        { label: '职位', value: f.job_title || '-' },
        { label: '工号', value: f.employee_no || '-' },
        { label: '飞书 user_id', value: f.user_id || '-' },
        { label: '飞书 union_id', value: f.union_id || '-' },
        { label: '飞书 open_id', value: f.open_id || '-' }
      ]
    }
  },
  methods: {
    async init() {
      await this.getUserList()
      this.rolesList = await this.$api.getUserRoles()
    },
    // 打开成员详情抽屉
    async openMemberDetail(row) {
      if (!row)
        return
      this.memberDetailTab = 'base'
      this.memberDetailData.title = '成员详情（' + (row.name || row.nickname || row.username) + '）'
      this.memberDetailData.visible = true
      this.memberDetailData.loading = true
      try {
        this.memberDetail = await this.$api.getMemberDetail(row.id)
      } finally {
        this.memberDetailData.loading = false
      }
    },
    // 关闭成员详情抽屉
    memberDetailClose() {
      this.memberDetailData.visible = false
      this.memberDetail = null
    },
    // 飞书信息-同步：拉取飞书最新成员信息并弹出确认更新
    async syncFeishu() {
      if (!this.memberDetail || !this.memberDetail.base || !this.memberDetail.base.id) {
        return
      }
      this.feishuSyncLoading = true
      this.feishuSyncData = null
      this.feishuSyncDialog.visible = true
      try {
        this.feishuSyncData = await this.$api.syncFeishuInfo(this.memberDetail.base.id)
        if (!this.feishuSyncData || !this.feishuSyncData.latest) {
          this.$message.warning('未获取到飞书最新成员信息')
        }
      } catch (e) {
        this.feishuSyncDialog.visible = false
      } finally {
        this.feishuSyncLoading = false
      }
    },
    // 飞书信息-确认更新为最新成员信息
    async confirmFeishuUpdate() {
      if (!this.memberDetail || !this.memberDetail.base || !this.memberDetail.base.id) {
        return
      }
      this.feishuSyncLoading = true
      try {
        this.memberDetail = await this.$api.updateFeishuInfo(this.memberDetail.base.id)
        this.feishuSyncDialog.visible = false
        this.msgSuccess('已更新为最新飞书成员信息')
      } catch (e) {
        // 失败提示由请求拦截器统一处理
      } finally {
        this.feishuSyncLoading = false
      }
    },
    // 时间线节点类型
    timelineType(type) {
      const map = { create: 'primary', ding_bind: 'success', fs_bind: 'warning', leave: 'danger' }
      return map[type] || 'info'
    },

    jumpToPage(pageName, params) {
      // this.$router.push({
      //   name: pageName,
      //   params: params
      // })
      const { href } = this.$router.resolve({
        name: pageName,
        params:params
      })
      window.open(href, '_blank')
    },
    changeTableSort({ prop, order }) {
      const orderSort = {}
      if (order) {
        orderSort[prop] = order === 'descending' ? 'desc' : 'asc'
      }
      this.orderSort = orderSort
      this.getUserList()

    },
    handleDeptSelect(arr) {
      this.searchCondition.dpt_id = arr ? arr[0] : null
      this.searchButton()
    },
    // 搜索
    searchButton() {
      this.pagingData.current_page = 1
      // this.$refs['apeTable'].handleCurrentChange(1)
      this.getUserList()
    },
    // 响应添加按钮
    async addButton() {
      this.drawerData.loading_text = '玩命加载中……'
      this.drawerData.visible = true
      this.drawerData.title = '添加用户'
      // let list = await this.$api.getUserRoles()
      // this.rolesList = list
      this.$nextTick(() => {
        this.drawerData.loading = false
      })
    },
    // 响应编辑按钮
    async editButton(id, type = 'edit') {
      const { info } = await this.$api.getUserInfo(id)
      this.formData = info
      if (type === 'edit') {
        this.drawerData.loading_text = '玩命加载中……'
        this.drawerData.visible = true
        this.drawerData.title = '编辑用户(UID：' + id + ')'
        // let list = await this.$api.getUserRoles()
        // this.rolesList = list
        this.drawerData.loading = false
      } else if (type === 'password') {
        this.passWordDialog = true
        this.generateRandomPassword()

      } else if (type === 'role') {
        this.roleDialog = true
      }
    },

    // 用户状态修改
    handleStatusChange(row) {
      const text = row.user_status === 1 ? '启用' : '停用'
      this.$confirm('确认要"' + text + '"："' + row.nickname + '"用户吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const info = await this.$api.changeUserStatus(row.id, row.user_status)
        if (info)
          this.msgSuccess(text + '成功')
      }).catch(function() {
        row.user_status = row.user_status === 0 ? 1 : 0
      })
    },
   async handleEventStatus(row){
    const userStatus = row.user_status === 1 ? 0 : 1
     const text = row.user_status === 1 ? '停用' : '启用'
     this.$confirm('确认要"' + text + '"："' + row.nickname + '"用户吗?', '警告', {
       confirmButtonText: '确定',
       cancelButtonText: '取消',
       type: 'warning'
     }).then(async () => {
       const info = await this.$api.changeUserStatus(row.id, userStatus)
       if (info)
         this.msgSuccess(text + '成功')

     }).catch(function() {
       // row.user_status = row.user_status === 0 ? 1 : 0
     })
    },

    // 处理抽屉关闭
    drawerClose() {
      this.initFormData()
      this.drawerData.visible = false
      this.drawerData.loading = true
      // this.rolesList = []
    },
    // 处理抽屉确认
    async drawerConfirm() {
      // 调用组件的数据验证方法
      this.$refs['userForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    async saveRole() {
      //roleDialog
      const id = await this.$api.editUserRole(this.formData)
      if (id) {
        this.$message.success('保存成功')
        this.roleDialog = false

      }
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      setTimeout(() => {
        this.drawerData.loading = false
      }, 1000)
      let id = this.formData.id
      if (!this.formData.id) {
        id = await this.$api.saveUser(this.formData)
      } else {
        //仅更新基础信息
        id = await this.$api.updateUser(this.formData)
      }

      this.$nextTick(() => {
        this.drawerData.visible = false
      })
      this.$nextTick(async () => {
        if (id) {
          await this.getUserList()
        }
      })
      this.$nextTick(() => {
        this.msgSuccess('保存成功!')
      })
      this.initFormData()
    },
    // 相应删除按钮
    async deleteButton(id) {
      this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const info = await this.$api.deleteUser(id)
        if (info) await this.getUserList()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 初始化数据
    initFormData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.formData = { user_roles: [] }
        this.$refs['userForm'].resetFields()
      })
    },
    sortChange({ prop, order }) {
      const orderSort = {}
      if (order) {
        orderSort[prop] = order === 'descending' ? 'desc' : 'asc'
      }
      this.orderSort = orderSort
      this.getUserList()
    },
    // 初始化用户列表
    async getUserList() {
      this.loadingStaus = true
      // let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      const pagingInfo = { page_size: this.pagingData.page_size, current_page: this.pagingData.current_page }
      const searchCondition = this.handleSearchCondition()
      // 合并
      Object.assign(searchCondition, pagingInfo, { order: this.orderSort })
      const { list, pages } = await this.$api.getUserList(searchCondition)

      this.$nextTick(() => {
        this.userList = list
      })
      this.pagingData.total = pages.total
      this.offset = pages.offset
      this.pagingData.offset = pages.offset
      this.pagingData.current_page = pages.current_page
      this.pagingData.page_size = pages.page_size
      setTimeout(() => {
        this.loadingStaus = false
      }, 500)
      this.loadingStaus = false
    },
    // 处理搜索条件
    handleSearchCondition() {
      const condition = {}

      Object.keys(this.searchCondition).forEach((field) => {
        if (this.searchCondition[field] != null && this.searchCondition[field] !== '') {
          condition[field] = this.searchCondition[field]
        }
      })
      if (this.currentField) {
        condition['currentField'] = this.currentField
      }


      return condition
    },
    async userGroupBinding(row) {
      this.drawerGroupData.loading_text = '玩命加载中……'

      this.currentUserId = row.id
      this.drawerGroupData.title = '分组绑定(UID：' + row.id + ')'
      const { groups_list, user_groups } = await this.$api.getUserGroups(row.id)
      this.groupList = groups_list
      // this.userGroups = user_groups

      user_groups.forEach((item) => {
        this.userGroups.push(Number(item))
      })
      if (user_groups.length === 0) {
        this.checkAll = false;
        this.isIndeterminate = false;
      } else {
        const isAllSelected = this.userGroups.length === groups_list.length;
        this.checkAll = isAllSelected;
        this.isIndeterminate = !isAllSelected;
      }
      this.$nextTick(() => {
        this.drawerGroupData.loading = false
        this.drawerGroupData.visible = true
      })

      // this.$router.push(this.$route.path + '/' + row.id + '/user-groups')
    },
    // 每一个权限组的全选状态
    checkedIndeterminate(val) {
      this.userGroups = val ? this.groupList.map((group) => {
        return group.name
      }) : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.groupList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.groupList.length
    },
    // 处理点击每个组的全选
    handleCheckAll(v) {
      if (v.checked_status) {
        this.rolePermissions[v.id] = v.children.map((val) => {
          return val.id
        })
      } else {
        this.rolePermissions[v.id] = []
      }
    },

    // 处理抽屉关闭
    drawerGroupClose() {
      this.userGroups = []
      this.groupList = []
      this.drawerGroupData.visible = false
      this.drawerGroupData.loading = true
    },
    // 处理抽屉确认
    async drawerGroupConfirm() {
      this.drawerGroupData.loading_text = '玩命提交中……'
      this.drawerGroupData.loading = true
      const params = {
        user_id: this.currentUserId,
        user_groups: this.userGroups
      }

      await this.$api.saveUserGroups(params)
      this.$nextTick(() => {
        this.drawerGroupData.visible = false
      })
      this.$nextTick(() => {
        this.msgSuccess('保存成功!')
      })
      this.userGroups = []
      this.groupList = []
    },

    // 用户登录日志
    async userLoginRecord(row) {
      this.drawerLoginData.loading_text = '玩命加载中……'
      this.drawerLoginData.visible = true
      this.currentUserId = row.id
      this.drawerLoginData.title = '登录日志记录(UID：' + row.id + ')'
      this.$nextTick(() => {
        this.$refs['userLoginRecord'].initList()
        this.drawerLoginData.loading = false
      })
    },
    // 处理抽屉关闭
    drawerLoginRecordClose() {
      this.drawerLoginData.visible = false
      this.drawerLoginData.loading = true
    },

    async exportExcel() {
      try {
        const name = `用户列表`
        const searchCondition = this.handleSearchCondition()
        // 合并
        Object.assign(searchCondition, { order: this.orderSort })
        const response = await this.$api.exportUserList(searchCondition)
        this.$refs.refExportLink.exportSaveXlsx(response, name)
      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
      }
    },

    jumpToDetail(row) {
      this.jumpToPage('UserDetail', { user_id: row.id })
    },
    // eslint-disable-next-line no-unused-vars
    dblclickRow(row, column, event) {
      event.preventDefault()
      if (column.property === 'nickname') {
        this.jumpToDetail(row)
        // this.$notify.info('详情')
      }
    },
    // eslint-disable-next-line no-unused-vars
    addCellClass({ row, column }) {
      if (column && column.property === 'nickname') {
        return 'cell-link'
      }
    },
    showBindDialog(row) {
      // this.$notify.success('显示钉钉账号')
      this.dialogVisible = true
      this.formData = { ...row }
      this.bindForm = { id: this.formData.id, userid: this.formData.userid, reason: null }
    },
    async saveBindDing() {
      this.$confirm('此操作将用户系统账号和钉钉账号绑定, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        // this.bindForm = { id: this.formData.id, userid: this.formData.userid }
        await this.$api.bindDingUser(this.bindForm)
        await this.getUserList()
        this.dialogVisible = false
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    generateRandomPassword() {
      const numbers = '0123456789'
      const lowercaseLetters = 'abcdefghijklmnopqrstuvwxyz'
      const uppercaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      const specialCharacters = '!@#$%^&*()_-+=][{}|;:,.<>?'
      let password = ''
      const availableChars = numbers + lowercaseLetters + uppercaseLetters + specialCharacters
      for (let i = 0; i < 12; i++) {
        const randomIndex = Math.floor(Math.random() * availableChars.length)
        password += availableChars[randomIndex]
      }
      this.$set(this.formData, 'password', password)
    },

    copyBtn() {
      this.$confirm('确认要重置:"' + this.formData.nickname + '"用户的密码吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const _t = this
        const id = await this.$api.changePwdUser(this.formData.id, this.formData.password)
        if (id) {
          this.copyInfo = `用户：${this.formData.nickname}\n手机号：${this.formData.mobile}\n重置后的密码为：${this.formData.password}\ntip:为了账户安全,请勤换密码哦~`
          this.$copyText(this.copyInfo).then(function() {
            _t.$message({
              message: '保存/复制成功！',
              type: 'success'
            })
          })
        } else
          _t.$message({
            message: '失败,请联系管理员！',
            type: 'error'
          })
        this.passWordDialog = false
      })
    },
    // eslint-disable-next-line no-unused-vars
    rowClickEvent(row, column, event) {
      // this.$notify.info(`数据ID：${row.id}`)
    },
    // eslint-disable-next-line no-unused-vars
    tableRowClassName({ row, rowIndex }) {
      return 'default-table-row'
    }

  },
  mounted() {
    if (this.$route.matched.length === 2) {
      this.init()
    }

  }
}
</script>
<style>
.cell-link {
  /*text-underline-offset: -10px;*/
  /*text-decoration-thickness: 10px;*/
  text-decoration-color: #ff3176;
  text-underline-position: under;
  text-decoration-line: underline;
}

.cell-link:hover {
  cursor: pointer;
}
</style>
<style lang='scss' scoped>
.member-detail {
  .detail-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px 32px;

    .detail-item {
      display: flex;
      flex-direction: column;

      .detail-label {
        color: #909399;
        font-size: 12px;
        line-height: 1.4;
      }

      .detail-value {
        color: #303133;
        font-size: 14px;
        line-height: 1.6;
        word-break: break-all;
      }
    }
  }

  .timeline-title {
    font-weight: 500;
    color: #303133;
  }

  .timeline-desc {
    color: #909399;
    font-size: 12px;
    margin-top: 4px;
  }

  .timeline-empty {
    color: #909399;
    text-align: center;
    padding: 40px 0;
  }

  .detail-toolbar {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;

    .toolbar-title {
      font-size: 14px;
      font-weight: 500;
      color: #303133;
    }
  }
}

.sync-section-title {
  margin: 12px 0 8px;
  font-size: 13px;
  font-weight: 600;
  color: #606266;
}

.feishu-sync-body {
  min-height: 120px;
}
</style>
